import { mapState } from "vuex"

export default {
  computed: {
    ...mapState({
      __notifications: (state) => state.notification.list,
      __last_reads: (state) => state.notification.last_reads,
    }),
    __sortedList: function () {
      const copy = [...this.__notifications]

      copy.sort((a, b) => {
        return b.id - a.id
      })
      return copy
    },
  },
  methods: {
    sort_set_by_notif: function ({ band_set, notif_standing }) {
      const cpy = [...band_set]

      return cpy.sort(
        function (a, b) {
          const a_score = this.__computeScore(a.id, notif_standing)
          const b_score = this.__computeScore(b.id, notif_standing)

          if (typeof a_score === "number" && typeof b_score === "number")
            return b_score - a_score
          else if (typeof a_score === "number") return -1
          else if (typeof b_score === "number") return 1
          else return b.id - a.id
        }.bind(this)
      )
    },
    __computeScore: function (elem, notif_standing) {
      if (notif_standing[elem]) {
        if (!this.__last_reads[elem] !== notif_standing[elem].latest)
          return notif_standing[elem].count
        else return false
      } else return false
    },
  },
}
